import React, { useRef, useState } from 'react'
import './contact.css'
import {RiMailSendLine, RiMessengerFill,RiWhatsappFill} from 'react-icons/ri'
import Swal from 'sweetalert2'
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';

const Contact = () => {
  const form = useRef();
  const { language } = useLanguage();
  const t = translations[language];
  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    
    fetch('https://formspree.io/f/xldlbkwe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: language === 'fr' ? "Votre message a été envoyé" : "Your message has been sent",
        });
        e.target.reset();
      } else {
        throw new Error('Erreur lors de l\'envoi');
      }
    })
    .catch((error) => {
      Swal.fire({ 
        icon: "error", 
        title: language === 'fr' ? "Erreur lors de l'envoi" : "Error sending message" 
      });
    })
    .finally(() => {
      setIsLoading(false);
    });
  };
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="contact">
      <motion.h5
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {t.contactSubtitle}
      </motion.h5>
      
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        {t.contactTitle}
      </motion.h2>
      
      <div className="container contact__container">
        <motion.div 
          className="contact__content"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <motion.div 
            className="contact__options"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article 
              className="contact__option"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05,
                y: -5,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <RiMailSendLine className="contact__option-icon" />
              <h4>Email</h4>
              <h5>lahminet0@gmail.com</h5>
              <a href="mailto:lahminet0@gmail.com">{t.sendMessage}</a>
            </motion.article>
            
            <motion.article 
              className="contact__option"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05,
                y: -5,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <RiMessengerFill className="contact__option-icon" />
              <h4>Messenger</h4>
              <h5>Cod Eur</h5>
              <a href="https://m.me/lamine.traore.1998/" rel="noreferrer">
                {t.sendMessage}
              </a>
            </motion.article>
            
            <motion.article 
              className="contact__option"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05,
                y: -5,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <RiWhatsappFill className="contact__option-icon" />
              <h4>WhatsApp</h4>
              <h5>+225 07 0405 1152</h5>
              <a
                href="https://wa.me/+2250704051152?text=Coucou"
                rel="noreferrer"
              >
                {t.sendMessage}
              </a>
            </motion.article>
          </motion.div>
        </motion.div>
        <motion.form 
          ref={form} 
          onSubmit={sendEmail}
          action="https://formspree.io/f/xldlbkwe"
          method="POST"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <motion.input
            name="nom"
            type="text"
            placeholder={language === 'fr' ? "Entrez votre nom" : "Enter your name"}
            required
            whileFocus={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          />
          <motion.input
            name="phone_number"
            type="text"
            placeholder={language === 'fr' ? "Entrez votre numéro de téléphone" : "Enter your phone number"}
            required
            whileFocus={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          />
          <motion.input
            name="email"
            type="email"
            placeholder={language === 'fr' ? "Entrez votre mail" : "Enter your email"}
            required
            whileFocus={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          />
          <motion.textarea
            name="message"
            placeholder={language === 'fr' ? "Votre message" : "Your message"}
            rows="7"
            required
            whileFocus={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          ></motion.textarea>
          <div className="contact__button">
            <motion.button 
              type="submit" 
              className="btn btn-primary"
              disabled={isLoading}
              whileHover={{ 
                scale: isLoading ? 1 : 1.05,
                y: isLoading ? 0 : -3,
                transition: { duration: 0.2 }
              }}
              whileTap={{ scale: isLoading ? 1 : 0.95 }}
            >
              {isLoading ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className="loading-spinner"></div>
                  {language === 'fr' ? 'Envoi en cours...' : 'Sending...'}
                </div>
              ) : (
                t.sendMessage
              )}
            </motion.button>
          </div>
        </motion.form>
      </div>
    </section>
  );
}

export default Contact